import { useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import './FilterParts.scss';

interface MoreFiltersToggleProps {
    open: boolean;
    /** Cuántos de los filtros de «Más filtros» están aplicados: se muestra entre paréntesis. */
    active: number;
    /** Id del bloque que despliega, para `aria-controls`. */
    controls: string;
    onToggle: () => void;
}

/** «Más filtros» (con la cantidad de filtros aplicados), alineado con los campos de la fila de filtros. */
export default function MoreFiltersToggle({ open, active, controls, onToggle }: MoreFiltersToggleProps) {
    const intl = useIntl();
    const label = active > 0
        ? intl.formatMessage({ id: 'MoreFiltersToggleCount' }, { count: active })
        : intl.formatMessage({ id: 'MoreFiltersToggle' });
    return (
        <div className="nv-more-toggle">
            <Button type="button" className="buttonMain3" label={label}
                icon={open ? 'pi pi-chevron-up' : 'pi pi-chevron-down'} iconPos="right"
                aria-expanded={open} aria-controls={controls}
                onClick={onToggle} />
        </div>
    );
}
